export default `
  mutation WebUpdateCustomer($customer: UpdateCustomerInput!) {
    UpdateCustomer(input: $customer) {
      customer {
        id
      }
      errors
      auto_redeem_exchange_card
      popup_sales_code_form
    }
  }
`
